import _ from 'lodash';

const labelValue = (value) => ({ label: value, value });
export function uniqueLabelValues(collection, mapping) {
  return _.uniq(collection.map(mapping).filter(Boolean)).sort().map(labelValue);
}
